const translateUtils = function () {
    return {
        getCustomizationPath: function (accuCode, locale) {
            return __styleEnv__ + "customizations/" + accuCode + "/locales/";
        }
    };
};
export default translateUtils();
